import { useState } from "react";
import styles from "../UI.module.css";
import { Box, Grid, GridItem } from "@chakra-ui/react";

function Accordion({
  order,
  data,
  id,
  type = "enroll",
}: {
  order: string;
  data: any;
  id: number;
  type?: string;
}) {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <div className={"py-2 pk-accordition"}>
      <div
        className={`${styles["pk-accordition-button"]} ${isOpened && styles.rotate}`}
        onClick={() => setIsOpened(!isOpened)}
      >
        <Box as="span" flex="1" textAlign="left">
          {order}
        </Box>
      </div>
      <div
        className={`${styles["pk-accordition-content"]} ${!isOpened && styles["pk-collapse"]}`}
        style={{ width: "95vw" }}
      >
        <table>
          <thead>
            <tr>
              <th
                style={{
                  minWidth: "150px",
                }}
              >
                СНИЛС/Личный номер
              </th>
              <th>Конкурс</th>
              {type === "enroll" && (
                <>
                  <th>Общежитие</th>
                  <th>Результаты ВИ</th>
                  <th>Баллы за индивидуальные достижения</th>
                  <th>Суммарный балл</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>

            {data.map((applicant: any) => {
              let ds = 'нет';
              switch (applicant.dp) {
                case 1:
                  ds = 'да';
                  break;
                case 2:
                  ds = 'да (партнёрское общежитие)';
                  break;
                  case 3:
                  ds = 'да (общежитие г. Фрязино)';
                  break;
                default:
                  ds = 'нет';
                  break;
              }

              return (
                <tr>
                  <td
                    style={{
                      minWidth: "50px",
                    }}
                  >
                    {applicant.pn}
                  </td>
                  <td>{applicant.epn}</td>
                  {type === "enroll" && (
                    <>
                      <td>{ds}</td>
                      <td
                        style={{
                          minWidth: "275px",
                        }}
                      >
                        {applicant.ees
                          ? JSON.parse(applicant.ees).map((score: string) => {
                              return (
                                <span style={{ fontSize: "12px" }}>
                                  {score}
                                  <br />
                                </span>
                              );
                            })
                          : "-"}
                      </td>
                      <td>{applicant.ias ? applicant.ias : "-"}</td>
                      <td>{applicant.ts ? applicant.ts : "-"}</td>
                    </>
                  )}
                </tr>
              )
            }
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Accordion;
